import React from 'react';
import moment from 'moment';
import Field from './fields/Field';
import FieldNumber from './fields/FieldNumber';
import FieldDatePicker from './fields/FieldDatePicker';
import RefineResultsModal from './RefineResult/RefineResultModal';
import useRefineResultState from './RefineResult/RefineResultState';
import FieldSelect from './fields/FieldSelect';
import { getTranslation } from '../lang/main';
import LocalizedMessage from "react-l10n";

const momentToday = moment();
const DATE_FIELD_FORMAT = 'DD/MM/YYYY';
const DATE_FIELD_SAVED_FORMAT = 'YYYY-MM-DD';

const INITIAL_FORM_STATE = {
    BusinessName: "",
    PurchaseOrderNumber: "",
    InternalItemID: '',
    Placed__GTE: '',
    Placed__LTE: '',
    // 'Placed__LTE': momentToday.format(DATE_FIELD_SAVED_FORMAT),
    'ignore:Placed__GTE': '', // for display purpose
    'ignore:Placed__LTE': '', // for display purpose
    // 'ignore:Placed__LTE': momentToday.format(DATE_FIELD_FORMAT), // for display purpose
    Status: '',
    ShippingStatus: '',
    PaymentMethod: '',
    Supplier: '',
    Total__GTE: '',
    Total__LTE: '',
    SKU: ''
};

const FORM_LABEL = {
    InternalItemID: getTranslation('FIELD.ORDER_NUMBER'),
    InvoiceInternalItemID: getTranslation('FIELD.INVOICE_NUMBER'),
    Placed__GTE: getTranslation('FIELD.DATE_FROM'),
    Placed__LTE: getTranslation('FIELD.DATE_UNTIL'),
    Status: getTranslation('FIELD.ORDER_STATUS'),
    ShippingStatus: getTranslation('FIELD.SHIPPING_STATUS'),
    PaymentMethod: getTranslation('FIELD.PAYMENT_TYPE'),
    Supplier: getTranslation('FIELD.SUPPLIER'),
    Total__GTE: getTranslation('FIELD.TOTAL_MIN'),
    Total__LTE: getTranslation('FIELD.TOTAL_MAX'),
    BusinessName: getTranslation('FIELD.BUSINESS_NAME'),
    PurchaseOrderNumber: getTranslation('FIELD.PurchaseOrderNumber'),
    SKU: getTranslation('FIELD.SKU'),
};

const IGNORED_DISPLAYED_FILTERS = ['MemberID'];

const ALL_ORDER_STATUSES = [
    'Unpaid',
    'Paid',
    'Awaiting Upstream Approval',
    'Awaiting Fulfilment',
    'Awaiting Payment',
    'Completed',
    'Cancelled',
    'Declined',
    'Refunded',
    'Disputed',
    'Manual Verification Required',
    'Marked As Paid',
];
const ALL_SHIPPING_STATUSES = [
    'Awaiting Shipment',
    'Awaiting Pickup',
    'Partially Shipped',
    'Shipped',
];

function OrderListRefineResults(props) {
    const {
        applyFilter,
        activeFilters,
        modalKey,
        ignoredOrderStatuses,
        ignoredShippingStatuses
    } = props;
    const {
        formData,
        bindUpdateFormData,
        bindUpdateFormDataNumber,
        updateFormDataBulk,
        clearFilter,
        clearAllFilters,
        submitForm,
        getManagedActiveFilters,
    } = useRefineResultState({
        initialFormState: INITIAL_FORM_STATE,
        formLabel: FORM_LABEL,
        applyFilter: applyFilter,
    });

    const updateFormDataDate = (key, date) => {
        updateFormDataBulk({
            ['ignore:' + key]: date,
            [key]: moment(date, DATE_FIELD_FORMAT).format(
                DATE_FIELD_SAVED_FORMAT
            ),
        });
    };

    const momentPlacedFrom = formData['ignore:Placed__GTE']
        ? moment(formData['ignore:Placed__GTE'], DATE_FIELD_FORMAT)
        : null;
    const momentPlacedUntil = formData['ignore:Placed__LTE']
        ? moment(formData['ignore:Placed__LTE'], DATE_FIELD_FORMAT)
        : null;

    const getAvailableOrderStatuses = () => {
        let status = [...ALL_ORDER_STATUSES];

        if (ignoredOrderStatuses && ignoredOrderStatuses.length) {
            status = status.map((item) => {
                if (ignoredOrderStatuses.indexOf(item) == -1) {
                    return item;
                }
            });
        }

        let dropdown = status.map((item) => {
            return {
                label: item,
                value: item,
            };
        });

        dropdown = [
            {
                label: getTranslation('FIELD.PLACEHOLDER.SELECT_ORDER_STATUS'),
                value: '',
            },
            ...dropdown,
        ];

        return dropdown;
    };

    const getAvailableShippingStatuses = () => {
        let status = [...ALL_SHIPPING_STATUSES];

        if (ignoredShippingStatuses && ignoredShippingStatuses.length) {
            status = status.map((item) => {
                if (ignoredShippingStatuses.indexOf(item) == -1) {
                    return item;
                }
            });
        }

        let dropdown = status.map((item) => {
            return {
                label: item,
                value: item,
            };
        });

        dropdown = [
            {
                label: getTranslation(
                    'FIELD.PLACEHOLDER.SELECT_SHIPPING_STATUS'
                ),
                value: '',
            },
            ...dropdown,
        ];

        return dropdown;
    };

    return (
        <RefineResultsModal
            modalKey={modalKey}
            activeFilters={getManagedActiveFilters(activeFilters)}
            clearFilter={(key) => clearFilter(key)}
            clearAllFilters={() => clearAllFilters()}
            ignoreDisplayingFilters={IGNORED_DISPLAYED_FILTERS}
        >
            <form method='POST' className='form' onSubmit={submitForm}>
                <Field
                    label={FORM_LABEL.InternalItemID}
                    animatedLabel={FORM_LABEL.InternalItemID}
                    name='InternalItemID'
                    value={formData.InternalItemID || ''}
                    onChange={bindUpdateFormData}
                />
                <Field
                    label={FORM_LABEL.InvoiceInternalItemID}
                    animatedLabel={FORM_LABEL.InvoiceInternalItemID}
                    name='InvoiceInternalItemID'
                    value={formData.InvoiceInternalItemID || ''}
                    onChange={bindUpdateFormData}
                />

                {/* 
                        <div className="row row--small">
                            <div className="col-xs-12 col-sm-6">
                                <FieldSelect
                                    label={FORM_LABEL.Status}
                                    animatedLabel={FORM_LABEL.Status}
                                    placeholder={FORM_LABEL.Status}
                                    name="Status"
                                    options={getAvailableOrderStatuses()}
                                    value={formData.Status || ''}
                                    onChange={bindUpdateFormData}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-6">
                                <FieldSelect
                                    label={FORM_LABEL.ShippingStatus}
                                    animatedLabel={FORM_LABEL.ShippingStatus}
                                    placeholder={FORM_LABEL.ShippingStatus}
                                    name="ShippingStatus"
                                    options={getAvailableShippingStatuses()}
                                    value={formData.ShippingStatus || ''}
                                    onChange={bindUpdateFormData}
                                />
                            </div>
                        </div>
                        */}

                {/* 
                        <div className="row row--small">
                            <div className="col-xs-12 col-sm-6">
                                <FieldDatePicker
                                    selectStart={true}
                                    maxDate={momentPlacedUntil}
                                    startDate={momentPlacedFrom}
                                    endDate={momentPlacedUntil}
                                    autoComplete="off"
                                    dateFormat={DATE_FIELD_FORMAT}
                                    placeholder="dd/mm/yyyy"
                                    label={FORM_LABEL.Placed__GTE}
                                    animatedLabel={FORM_LABEL.Placed__GTE}
                                    name="Placed__GTE"
                                    value={formData['ignore:Placed__GTE'] || ''}
                                    onChange={(date) => updateFormDataDate('Placed__GTE', date)}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-6">
                                <FieldDatePicker
                                    selectsEnd={true}
                                    minDate={momentPlacedFrom}
                                    startDate={momentPlacedFrom}
                                    endDate={momentPlacedUntil}
                                    autoComplete="off"
                                    dateFormat={DATE_FIELD_FORMAT}
                                    placeholder="dd/mm/yyyy"
                                    label={FORM_LABEL.Placed__LTE}
                                    animatedLabel={FORM_LABEL.Placed__LTE}
                                    name="Placed__LTE"
                                    value={formData['ignore:Placed__LTE'] || ''}
                                    onChange={(date) => updateFormDataDate('Placed__LTE', date)}
                                />
                            </div>
                        </div>
                        */}

                <div className='row row--small'>
                    <div className='col-xs-12 col-sm-6'>
                        <FieldNumber
                            allowDecimals={true}
                            label={FORM_LABEL.Total__GTE}
                            animatedLabel={FORM_LABEL.Total__GTE}
                            name='Total__GTE'
                            value={formData.Total__GTE || ''}
                            onChange={bindUpdateFormDataNumber}
                        />
                    </div>
                    <div className='col-xs-12 col-sm-6'>
                        <FieldNumber
                            allowDecimals={true}
                            label={FORM_LABEL.Total__LTE}
                            animatedLabel={FORM_LABEL.Total__LTE}
                            name='Total__LTE'
                            value={formData.Total__LTE || ''}
                            onChange={bindUpdateFormDataNumber}
                        />
                    </div>
                </div>

                <div className='row row--small'>
                    <div className='col-xs-12 col-sm-12'>
                        <Field
                            label={FORM_LABEL.BusinessName}
                            animatedLabel={FORM_LABEL.BusinessName}
                            name='BusinessName'
                            value={formData.BusinessName || ''}
                            onChange={bindUpdateFormData}
                        />
                    </div>
                </div>

                <div className='row row--small'>
                    <div className='col-xs-12 col-sm-6'>
                        <Field
                            label={FORM_LABEL.PurchaseOrderNumber}
                            animatedLabel={FORM_LABEL.PurchaseOrderNumber}
                            name='PurchaseOrderNumber'
                            value={formData.PurchaseOrderNumber || ''}
                            onChange={bindUpdateFormData}
                        />
                    </div>
                    <div className='col-xs-12 col-sm-6'>
                        <Field
                            label={FORM_LABEL.SKU}
                            animatedLabel={FORM_LABEL.SKU}
                            name='SKU'
                            value={formData.SKU || ''}
                            onChange={bindUpdateFormData}
                        />
                    </div>
                </div>

                {/* 
                        <div className='row row--small'>
                            <div className='col-xs-12 col-sm-6'>
                                <FieldNumber
                                    allowDecimals={true}
                                    label={FORM_LABEL.Placed__GTE}
                                    animatedLabel={FORM_LABEL.Placed__GTE}
                                    name='Placed__GTE'
                                    value={formData.Placed__GTE || ''}
                                    onChange={bindUpdateFormDataNumber}
                                />
                            </div>
                            <div className='col-xs-12 col-sm-6'>
                                <FieldNumber
                                    allowDecimals={true}
                                    label={FORM_LABEL.Placed__LTE}
                                    animatedLabel={FORM_LABEL.Placed__LTE}
                                    name='Placed__LTE'
                                    value={formData.Placed__LTE || ''}
                                    onChange={bindUpdateFormDataNumber}
                                />
                            </div>
                        </div>
                        */}

                <div className="row row--small">
                    <div className="col-xs-12 col-sm-6">
                        <FieldDatePicker
                            selectStart={true}
                            maxDate={momentPlacedUntil}
                            startDate={momentPlacedFrom}
                            endDate={momentPlacedUntil}
                            autoComplete="off"
                            dateFormat={DATE_FIELD_FORMAT}
                            placeholder="dd/mm/yyyy"
                            label={FORM_LABEL.Placed__GTE}
                            animatedLabel={FORM_LABEL.Placed__GTE}
                            name="Placed__GTE"
                            value={formData['ignore:Placed__GTE'] || ''}
                            onChange={(date) => updateFormDataDate('Placed__GTE', date)}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <FieldDatePicker
                            selectsEnd={true}
                            minDate={momentPlacedFrom}
                            startDate={momentPlacedFrom}
                            endDate={momentPlacedUntil}
                            autoComplete="off"
                            dateFormat={DATE_FIELD_FORMAT}
                            placeholder="dd/mm/yyyy"
                            label={FORM_LABEL.Placed__LTE}
                            animatedLabel={FORM_LABEL.Placed__LTE}
                            name="Placed__LTE"
                            value={formData['ignore:Placed__LTE'] || ''}
                            onChange={(date) => updateFormDataDate('Placed__LTE', date)}
                        />
                    </div>
                </div>


                <div className='row'>
                    <div className='col-xs-5'>
                        <button
                            type='button'
                            className='button button--field button--transparent button--block'
                            data-dismiss='modal'
                            title={getTranslation('CANCEL')}
                        >
                            <span><LocalizedMessage id={'CANCEL'} /></span>
                        </button>
                    </div>
                    <div className='col-xs-7'>
                        <button
                            type='submit'
                            className='button button--field button--block'
                            // data-dismiss="modal"
                            title={getTranslation('APPLY_FILTERS')}
                        >
                            <span> <LocalizedMessage id={'APPLY_FILTERS'} />  </span>
                        </button>
                    </div>
                </div>
            </form>
        </RefineResultsModal>
    );
}

export default OrderListRefineResults;
